// @flow
import React from 'react';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { TourInformation } from 'Components/widgets/tour-information/TourInformation';
import { type TourIntroductionDescriptorProps } from 'Client/cms/toolkit/tour-introduction/tourIntroduction.resolver';

type TourIntroductionLineProps = {
  ...$Exact<TourIntroductionDescriptorProps>,
  resort: {
    strengths: null | Array<string>,
    details: null | Array<string>,
  },
};

export const TourIntroductionLine = ({
  highlightTitle,
  resort,
  roadmapTitle,
}: TourIntroductionLineProps) => {
  const { details, strengths } = resort;
  const infos = [];
  if (details && details.length) {
    infos.push({ title: roadmapTitle, items: details });
  }
  if (strengths && strengths.length) {
    infos.push({ title: highlightTitle, items: strengths });
  }
  if (!infos.length) {
    return null;
  }

  return (
    <SiteContainer className="Line">
      <TourInformation infos={infos} />
    </SiteContainer>
  );
};
